module.exports = __webpack_public_path__ + "img/card-end-term-hover.63fd63ad.svg";